import { NextPage, NextPageContext } from 'next'
import Head from 'next/head'
import Router from 'next/router'
import { useEffect } from 'react'
import styled from 'styled-components'

import RequestResetPassword from 'modules/ResetPassword/RequestReset'

import ApiCreator from 'services/api'
import { useCloseHeaderModal } from 'services/hooks'
import { useUser } from 'services/swr/useUser'

const PageContainer = styled.div`
  width: 100%;
  height: calc(100vh - ${props => props.theme.metrics.headerHeightPhone}px);
  display: flex;
  justify-content: center;

  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    height: calc(100vh - ${props => props.theme.metrics.headerHeight}px);
  }
`

const ResetPasswordPage: NextPage = () => {
  useCloseHeaderModal()

  // if user comes back to original reset password tab after reseting password/logging in
  // we should reroute them back to homepage automatically
  const { user } = useUser()
  useEffect(() => {
    if (user) Router.replace('/home')
  }, [user])

  return (
    <PageContainer>
      <Head>
        <title>Reset Password - HomeLister</title>
        <meta
          name="description"
          content="Reset your Password at HomeLister"
        />
        <meta
          name="keywords"
          content="Password Reset, HomeLister"
        />
      </Head>
      <RequestResetPassword />
    </PageContainer>
  )
}

export const getServerSideProps = async (ctx: NextPageContext) => {
  try {
    // reroute serverside if user is logged in when requesting page
    const api = new ApiCreator(ctx)
    const response = await api.getMe()
    if (!response.ok) throw new Error(response.problem)

    if (response.data) {
      return {
        redirect: {
          permanent: false,
          destination: '/',
        },
      }
    }

    return { props: {} }
  } catch (err) {
    return { props: {} }
  }
}

export default ResetPasswordPage
